import React from 'react';
import { SocketContext } from 'contexts';

const useSocket = () => React.useContext(SocketContext);

export default useSocket;
